import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56ac228a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stock-jp-help" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"stock-jp-help-title\" data-v-56ac228a>D2C日本倉庫向け事前納品ガイド</div><div class=\"total-content\" data-v-56ac228a><div class=\"title\" data-v-56ac228a>■ 全体の流れ</div><div class=\"total-container\" data-v-56ac228a><div class=\"item\" data-v-56ac228a><img src=\"https://static-jp.theckb.com/static-asset/StockJpManual/icon3.png\" alt=\"\" data-v-56ac228a><span data-v-56ac228a> 「お客様」D2C在庫保有注文を発注 </span></div><img src=\"https://static-jp.theckb.com/static-asset/StockJpManual/arrow.png\" alt=\"\" class=\"arrow\" data-v-56ac228a><div class=\"item\" data-v-56ac228a><img src=\"https://static-jp.theckb.com/static-asset/StockJpManual/icon2.png\" alt=\"\" data-v-56ac228a><span data-v-56ac228a> 「THE CKB」中国仕入れ ・中国倉庫で検品 </span></div><img src=\"https://static-jp.theckb.com/static-asset/StockJpManual/arrow.png\" alt=\"\" class=\"arrow\" data-v-56ac228a><div class=\"item\" data-v-56ac228a><img src=\"https://static-jp.theckb.com/static-asset/StockJpManual/icon1.png\" alt=\"\" data-v-56ac228a><span data-v-56ac228a> 「お客様」良品の日本倉庫搬送を申請 </span></div><img src=\"https://static-jp.theckb.com/static-asset/StockJpManual/arrow.png\" alt=\"\" class=\"arrow\" data-v-56ac228a><div class=\"item\" data-v-56ac228a><img src=\"https://static-jp.theckb.com/static-asset/StockJpManual/icon4.png\" alt=\"\" data-v-56ac228a><span data-v-56ac228a> 「THE CKB」日本倉庫へ納品 </span></div></div><div class=\"total-text\" data-v-56ac228a>THE CKBでは、D2C形式のご注文商品を日本倉庫に事前納品・保管し、スムーズに出荷できる仕組みをご用意しています。</div></div>", 2)
const _hoisted_4 = { class: "container-text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-title" }, "■ 操作ステップ", -1))
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 1,
  class: "title2"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["innerHTML"]

import { t } from '@/plugins/i18n'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const content: any = [
  {
    title1: '① D2C在庫の確保（ご注文時）',
    text: 'ご注文の際、<b>「保管予定倉庫」</b>を <b>日本倉庫</b> に切り替えてください。 すべての商品がTHE CKB中国倉庫に到着し、検品が完了しましたら、メールおよびマイページ内の「メッセージ」にてご連絡いたします。 ',
    text2: 'その後、日本倉庫への搬送申請を行ってください。',
    img: ['https://static-jp.theckb.com/static-asset/stock_jp/1.jpg', 'https://static-jp.theckb.com/static-asset/stock_jp/2.jpg']
  },
  {
    title1: '② 日本倉庫への搬送申請',
    title2: '▼申請方法：',
    text: 'マイページ ＞ 国際配送管理 ＞ 国際配送依頼',
    text2: '→ 「日本倉庫への搬送依頼」をクリックして申請',
    img: ['https://static-jp.theckb.com/static-asset/stock_jp/4.jpg']
  },
  {
    title1: '③ 日本搬送依頼の提出',
    text: '申請時には、以下の内容を入力または選択してください。<br/>・通関情報 <br/>・追加オプション（例：ラベル貼り・梱包指示など）<br/>・配送方法（運送会社）の選択<br/><br/>※ 日本倉庫での受入れ・検品をスムーズに行うため、<b>「ラベル貼り付け」</b>や<b>「段ボール箱」</b>などの梱包オプションの選択が必要です。<br/><br/>※搬送対象となるのは、ご注文時に「日本倉庫」を選択した商品のみです。',
    img: ['https://static-jp.theckb.com/static-asset/stock_jp/5.jpg', 'https://static-jp.theckb.com/static-asset/stock_jp/6.jpg', 'https://static-jp.theckb.com/static-asset/stock_jp/7.jpg']
  },
  {
    title1: '④ 日本倉庫での在庫確認',
    text: '商品がTHE CKB日本倉庫に到着し、入荷・入庫処理が完了すると、システム上で日本倉庫在庫を確認できるようになります。',
    text2: ' 日本倉庫に在庫がある商品は、日本国内の注文に対して直接出荷が可能です。',
    img: ['https://static-jp.theckb.com/static-asset/stock_jp/8.jpg']
  }
]

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(content, (item, index) => {
        return _createElementVNode("div", {
          class: "text-item",
          key: index
        }, [
          (item.title1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "title1",
                innerHTML: item.title1
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true),
          (item.title2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(item.title2), 1))
            : _createCommentVNode("", true),
          (item.text)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "text",
                innerHTML: item.text
              }, null, 8, _hoisted_8))
            : _createCommentVNode("", true),
          (item.text2)
            ? (_openBlock(), _createElementBlock("div", {
                key: 3,
                class: "text",
                innerHTML: item.text2
              }, null, 8, _hoisted_9))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.img, (temp, key) => {
            return (_openBlock(), _createBlock(_component_el_image, {
              src: temp + '?v=2',
              alt: "",
              key: key,
              class: "img",
              "preview-src-list": [temp]
            }, null, 8, ["src", "preview-src-list"]))
          }), 128))
        ])
      }), 64))
    ])
  ]))
}
}

})